export default __webpack_public_path__ + "static/media/t.9b35711b.svg";